import React, { useEffect, useState } from 'react'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormHelperText,
} from '@material-ui/core'
import Table from '@material-ui/core/Table'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import TableBody from '@material-ui/core/TableBody'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import moment from 'moment/moment'
import Input from '@material-ui/core/Input'
import { StyledTableHead } from '../Approvals/ProjectsView.styles'
import { StyledApproveButton, StyledMutedButton } from '../Approvals/ApprovalView.styles'

const splitExpense = expense => {
  const half = Number(expense.amount) / 2
  return [
    {
      ...expense,
      amount: half,
    },
    {
      ...expense,
      amount: half,
    },
  ]
}

const SplitExpensesDialog = ({ open, onAccept, onCancel, expenseToSplit }) => {
  const [expenses, setExpenses] = useState([])
  const [actions, setActions] = useState([])

  useEffect(() => {
    if (expenseToSplit) {
      setExpenses(splitExpense(expenseToSplit))
      setActions(['bill', 'writeoff'])
    }
  }, [expenseToSplit])

  const handleChangeHours = (idx, rawValue) => {
    const value = parseFloat(rawValue) || 0
    const newEntries = [...expenses]
    newEntries[idx].amount = value
    setExpenses(newEntries)
  }

  const handleActionChange = (idx, value) => {
    setActions(prev => {
      const next = [...prev]
      next[idx] = value
      return next
    })
  }

  if (!open || !expenseToSplit) return null

  const totalEnteredHours = expenses.reduce((sum, e) => sum + Number(e.amount), 0)
  const maxAmount = expenseToSplit.amount
  const isValid = totalEnteredHours <= maxAmount

  // Compose split entries with status for backend
  const expensesWithActions = expenses.map((e, idx) => {
    let status
    if (actions[idx] === 'writeoff') status = 'WRITEOFF'
    else if (actions[idx] === 'defer') status = "'RAW'"
    else status = 'RAW'

    return {
      ...e,
      amount: Number(e.amount),
      status,
    }
  })

  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>Split expense</DialogTitle>
      <DialogContent>
        <Table aria-label="simple table">
          <StyledTableHead>
            <TableRow>
              <TableCell width={200}>Action</TableCell>
              <TableCell width={200}> Amount</TableCell>
            </TableRow>
          </StyledTableHead>
          <TableBody>
            {expenses.map((expense, idx) => (
              <TableRow key={`${expense._id}-${idx}`}>
                <TableCell>
                  <Select
                    value={actions[idx] || 'bill'}
                    onChange={ev => handleActionChange(idx, ev.target.value)}
                  >
                    <MenuItem value="bill">Bill</MenuItem>
                    <MenuItem value="writeoff">Write Off</MenuItem>
                    <MenuItem value="defer">Defer</MenuItem>
                  </Select>
                  {actions[idx] === 'defer' && (
                    <span style={{ fontSize: 12, marginLeft: 8 }}>
                      {moment
                        .utc()
                        .add(1, 'month')
                        .format('MMMM YYYY')}
                    </span>
                  )}
                </TableCell>
                <TableCell width={80}>
                  <Input
                    type="number"
                    inputProps={{ min: 0 }}
                    value={expense.amount}
                    onChange={ev => handleChangeHours(idx, ev.target.value)}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        {!isValid && (
          <FormHelperText error>
            Sum of amount must be less than or equal to {maxAmount}
          </FormHelperText>
        )}
      </DialogContent>
      <DialogActions>
        <StyledMutedButton onClick={onCancel}>Cancel</StyledMutedButton>
        <StyledApproveButton
          onClick={() => onAccept(expenseToSplit, expensesWithActions, actions)}
          disabled={!isValid}
        >
          Confirm
        </StyledApproveButton>
      </DialogActions>
    </Dialog>
  )
}
export default SplitExpensesDialog
